import { ShapeCombo, ShapeComboOptions } from "../Shape";
import LineShape from "./LineShape";

export class TreeShapeCombo extends ShapeCombo {
  private length = 100;

  constructor(options?: ShapeComboOptions) {
    super(options);

    const line1 = new LineShape({
      drag: {
        followSibling: true
      },
      lineLength: this.length
    });
    this.addShape(line1);

    const line2 = new LineShape({
      drag: {
        followSibling: true
      },
      lineLength: 20 + Math.random() * 20
    });
    this.addShape(line2, {
      dX: 90 - Math.random() * 40,
      dDegree: Math.random() * 70
    });

    const line3 = new LineShape({
      drag: {
        followSibling: true
      },
      lineLength: 20 + Math.random() * 20
    });
    this.addShape(line3, {
      dX: 90 - Math.random() * 40,
      dDegree: -Math.random() * 70
    });

    this.comboRotate(-90, true);
  }

  protected cloneShapeCombo(): TreeShapeCombo {
    const shapeCombo = new TreeShapeCombo(super.getBaseOptions());
    return shapeCombo;
  }
}

export default TreeShapeCombo;
